import { useEffect, useState } from 'react'
import type { AdaptiveCardChoice } from '../../store/slices/adaptiveCardSlice' 

const useCurrentValue = (instanceId?: string): Record<string, string | number | Array<string> | Array<number> | AdaptiveCardChoice | boolean> | undefined => {
  const [current, setCurrent] = useState<Record<string, string | number | Array<string> | Array<number> | AdaptiveCardChoice | boolean> | undefined>(undefined)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_currentValue', ((e: CustomEvent) => handleChange(e)) as EventListener)
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_currentValue'))

    return () => {
      document.removeEventListener('retorik_currentValue', ((e: CustomEvent) => handleChange(e)) as EventListener)
    }
  }, [])

  return current
}

export default useCurrentValue
